export const GET_PAYMENTS_SUCCESS = 'GET_PAYMENTS_SUCCESS';
export const SET_PAYMENT_DATA_LOADING = 'SET_PAYMENT_DATA_LOADING';
export const SET_PAYMENT_FORM_ITEM = 'SET_PAYMENT_FORM_ITEM';
export const CLEAR_PAYMENT_FORM_ITEM = 'CLEAR_PAYMENT_FORM_ITEM';
export const CLEAR_PAYMENT_FORM_ERRORS = 'CLEAR_PAYMENT_FORM_ERRORS';
export const SET_HAS_VERIFY_CC_ERROR = 'SET_HAS_VERIFY_CC_ERROR';
